import { Alert, AlertLevel } from '@vizit/atoms';

enum LoginError {
  InvalidCredentials = 'invalid_credentials',
  SessionExpired = 'session_expired',
}

interface LoginErrorAlertProps {
  /**
   * The error to display
   *
   * @required
   * @type {LoginError}
   */
  error: LoginError;
}

/**
 * A component that displays an error message for the login form.
 *
 * @param props - The component props
 * @param props.error - The error to display
 *
 * @returns The LoginErrorAlert component
 */
function LoginErrorAlert(props: LoginErrorAlertProps) {
  const { error = LoginError.InvalidCredentials } = props;

  return (
    <>
      {error === LoginError.InvalidCredentials && (
        <Alert className="min-w-[316px] animate-fade-in" level={AlertLevel.Error}>
          <Alert.Description>Invalid email or password.</Alert.Description>
        </Alert>
      )}
      {error === LoginError.SessionExpired && (
        <Alert className="min-w-[316px] animate-fade-in" level={AlertLevel.Error}>
          <Alert.Description>Session expired. Please log in again.</Alert.Description>
        </Alert>
      )}
    </>
  );
}

export { LoginErrorAlert, LoginError };
export type { LoginErrorAlertProps };
